import styled, { css } from 'styled-components';
import { BannerVariant } from './types';
import { AnalyticsLink, SecondaryButton } from '../Button';
import { IconWrapper } from '../Icon';
import { colors } from '../../config/styles';
import { theme } from '../../styles/theme';

export const Highlight = styled.span`
  font-weight: 600;
`;

export const Link = styled(AnalyticsLink)`
  color: inherit;
  font-weight: 600;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

export const ButtonLink = styled(SecondaryButton)``;

export const StyledBanner = styled.div<{
  $variant: BannerVariant;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  position: relative;
  padding: 10px 16px;
  gap: 8px;
  font-size: 14px;
  line-height: 1.5;

  /* Variant-specific styling */
  ${({ $variant }) => {
    switch ($variant) {
      case 'warning':
        // the color of the text should adjust when a design for the diffrent banners is done
        return css`
          background-color: ${colors.warningBanner};
          color: ${theme.colors.primaryBlack};
        `;
      case 'disabled':
        return css`
          background-color: ${theme.colors.grayscale300};
        `;
      case 'info':
        return css`
          background-color: ${theme.colors.blue500};
        `;
      // there is no design for those cases but as soon as there are colors theys should be implemented
      case 'error':
      default:
        return '';
    }
  }}
`;

export const BannerContent = styled.div<{
  $centerContent?: boolean;
}>`
  flex: ${({ $centerContent }) => ($centerContent ? 'none' : '1')};
`;

export const BannerCloseButton = styled(IconWrapper)`
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;

  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);

  &:hover {
    opacity: 1;
  }
`;

export const RightSide = styled.div`
  margin-left: auto;
`;
